$(function(){

    setTimeout(function(){

        $('#insta-feed').show();

        $('#insta-feed').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            arrows: true,
            dots: false,
            mobileFirst: true,
            appendArrows: $('.insta-arrows'),
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 639,
                    settings: {
                        slidesToScroll: 1,
                        variableWidth: true
                    }
                }
            ]
        });

    }, 3000);

});